/*
 * @Descripttion:
 * @Author: xiang.gao xiang.gao@travel-easy.com
 * @Date: 2022-09-30 10:50:50
 * @LastEditors: xiang.gao xiang.gao@travel-easy.com
 * @LastEditTime: 2023-01-20 15:33:14
 */
import { RouteLocationNormalizedLoaded } from "vue-router";
import { TaggingItem } from "../interface/common";
import { BadgeStyle, CommonLanguageType } from "../type/common";
import {
  OrderRequestProgress,
  OrderRequestType,
  invoiceStatus,
} from "../type/orderRequest";

export const getMerchantOrderProgress = (
  route: RouteLocationNormalizedLoaded
) => {
  let value: string[] = [];
  if (route.path.match("order-request")) {
    value = [
      String(OrderRequestProgress.Draft),
      String(OrderRequestProgress.New),
      String(OrderRequestProgress.Requested),
    ];
  } else if (route.path.match("order-processing")) {
    value = [
      String(OrderRequestProgress.Confirmed),
      String(OrderRequestProgress.Rejected),
      String(OrderRequestProgress.Shipped),
      String(OrderRequestProgress.Canceled),
      String(OrderRequestProgress.Completed),
    ];
  }
  return value;
};

export const getMerchantOrderInvoiceStatus = (
  status: number
): BadgeStyle | undefined => {
  const result = new Map([
    [invoiceStatus.Pending, BadgeStyle.LightWarning],
    [invoiceStatus.Invoiced, BadgeStyle.LightSuccess],
    [invoiceStatus.Paid, BadgeStyle.LightSuccess],
    [invoiceStatus.Unpaid, BadgeStyle.LightDanger],
  ]);
  return result.get(status);
};

export const getMerchantOrderRouterPath = (
  route: RouteLocationNormalizedLoaded
) => {
  let routerUrl = "";
  if (route.path.match("order-request")) {
    routerUrl = "/merchant-order/order-request";
  } else if (route.path.match("order-processing")) {
    routerUrl = "/merchant-order/order-processing";
  } else {
    routerUrl = "/merchant-order/order-overview";
  }
  return routerUrl;
};

/**
 * @description: 获取订单需求状态（样式）
 * @return CommonStatus
 */
export const getOrderRequestProgressClass = (status: number): string => {
  let statusClass = "";
  switch (status) {
    case OrderRequestProgress.Draft:
      statusClass = BadgeStyle.LightPrimary; // 蓝
      break;
    case OrderRequestProgress.New:
      statusClass = BadgeStyle.LightWarning; // 黄
      break;
    case OrderRequestProgress.Requested:
      statusClass = BadgeStyle.LightPrimary; // 蓝
      break;
    case OrderRequestProgress.Confirmed:
      statusClass = BadgeStyle.LightSuccess; // 绿
      break;
    case OrderRequestProgress.Rejected:
      statusClass = BadgeStyle.LightDark; // 绿
      break;
    case OrderRequestProgress.Shipped:
      statusClass = BadgeStyle.LightInfo; // 紫
      break;
    case OrderRequestProgress.Canceled:
      statusClass = BadgeStyle.LightDark; // 黑
      break;
    default:
      statusClass = BadgeStyle.LightPrimary; // 蓝
  }
  return statusClass;
};

export const getOrderRequestTypeOptions = (
  language: CommonLanguageType
): TaggingItem[] => {
  return [
    {
      label: language("orderRequest.merchantOrder"),
      value:
        String(OrderRequestType.MerchantOrder) +
        "," +
        String(OrderRequestType.Draft),
    },
    {
      label: language("orderRequest.agentPurchaseOrder"),
      value: String(OrderRequestType.AgentPurchaseOrder),
    },
    {
      label: language("common.doubleSaleOrder"),
      value: String(OrderRequestType.DoubleSaleOrder),
    },
  ];
};
